import React from "react";
import { useI18n } from "@/contexts/LanguageContext";
import { FmarkIcon } from "@/components/BrandMark";

export default function RouteLoading() {
  const { t } = useI18n();
  return (
    <div className="min-h-[50vh] flex items-center justify-center p-8" role="status" aria-live="polite">
      <div className="bg-white border-2 border-ink shadow-brutal px-8 py-7 flex flex-col items-center gap-4">
        <FmarkIcon className="h-9 w-auto animate-pulse" fill="#09090B" />
        <div className="flex items-center gap-1.5" aria-hidden="true">
          <span className="w-1.5 h-1.5 bg-safety rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-1.5 h-1.5 bg-safety rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="w-1.5 h-1.5 bg-safety rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
        <div className="font-mono text-[11px] uppercase tracking-widest text-steel">{t.common.loading}</div>
      </div>
    </div>
  );
}
